import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, switchMap, of} from "rxjs";
import {FintechService} from "./fintech.service";

export interface Transaction {
    date: Date;
    amount: number;
    balance: number;
    type?: string;
    description?: string;
    status?: string;
}

@Injectable({
    providedIn: 'root'
})
export class AiBalanceService {
    balance$ = new BehaviorSubject<number>(0.0);
    transactionHistory$ = new BehaviorSubject<Transaction[]>([]);

    constructor(private http: HttpClient,
                private fintechService: FintechService) {
        // Get balance from API
        /*???
        this.fintechService.getPayerToken().pipe(
            switchMap(payerToken => {
                const url = "https://ai.signage.me/aiBalance/getBalance";
                const options = {token: payerToken};
                return this.http.post(url, options);
            })
        ).subscribe( ret => {
            this.updateBalance(<number>(<any>ret).balance);
        });

        // Get transaction history from API
        this.loadTransactionHistory();

         */
    }


    addCredit(i_amount): Observable<any> {
        return this.fintechService.getPayerToken().pipe(
            switchMap(payerToken => {
                const url = "https://ai.signage.me/aiBalance/addCredit";
                const options = {
                    token: payerToken,
                    amount: i_amount
                };
                return this.http.post(url, options);
            }),
            switchMap((response) => {
                // After successful credit addition, reload the transaction history
                this.loadTransactionHistory();

                // Also update the balance if returned in response
                if (response && (<any>response).balance !== undefined) {
                    this.updateBalance((<any>response).balance);
                } else {
                    // If no balance in response, fetch it again
                    this.fintechService.getPayerToken().pipe(
                        switchMap(payerToken => {
                            const url = "https://ai.signage.me/aiBalance/getBalance";
                            const options = {token: payerToken};
                            return this.http.post(url, options);
                        })
                    ).subscribe(ret => {
                        this.updateBalance(<number>(<any>ret).balance);
                    });
                }

                return of(response);
            })
        );
    }

    updateBalance(balance)
    {
        this.balance$.next(balance);
    }

    getTransactionHistory(): Observable<Transaction[]> {
        return this.transactionHistory$.asObservable();
    }

    refreshTransactionHistory() {
        this.loadTransactionHistory();
    }

    private loadTransactionHistory() {
        this.fintechService.getPayerToken().pipe(
            switchMap(payerToken => {
                const url = "https://ai.signage.me/aiBalance/getHistory";
                const options = {token: payerToken};
                return this.http.post(url, options);
            })
        ).subscribe(
            (response: any) => {
                if (response && response.history) {
                    const transactions: Transaction[] = response.history.map((item: any) => ({
                        date: new Date(item.date),
                        amount: item.amount,
                        balance: item.balance,
                        type: item.type,
                        description: item.description,
                        status: item.status
                    }));
                    this.transactionHistory$.next(transactions);
                }
            },
            error => {
                console.error('Error loading transaction history:', error);

            }
        );
    }

    // Method to add usage transaction (for future use when AI services are consumed)
    addUsageTransaction(amount: number, description: string) {
        const currentBalance = this.balance$.getValue();
        const newBalance = currentBalance - amount;
        const newTransaction: Transaction = {
            date: new Date(),
            amount: -amount,
            balance: newBalance,
            type: 'Usage',
            description: description,
            status: 'Completed'
        };

        const currentHistory = this.transactionHistory$.getValue();
        this.transactionHistory$.next([newTransaction, ...currentHistory]);
        this.updateBalance(newBalance);
    }
}
